// Copyright (c) 2005-2019, Coveo Solutions Inc.
"use strict";
var Coveo = require("coveo-search-ui");
var OmniboxResultListHandler = (function () {
    function OmniboxResultListHandler() {
    }
    OmniboxResultListHandler.getOmniboxDataRowIndex = function () {
        this.omniboxDataRowIndexCounter = this.omniboxDataRowIndexCounter + 1;
        return this.omniboxDataRowIndexCounter;
    };
    OmniboxResultListHandler.prototype.onOmniboxRowClicked = function (result) {
        window.location.href = result.clickUri;
    };
    OmniboxResultListHandler.prototype.buildOmniboxContent = function (results, options) {
        var _this = this;
        var id = options.id ? options.id : options.resultTemplateId;
        var templateElement = document.getElementById(id);
        var template = new Coveo.UnderscoreTemplate(templateElement);
        var resultContainer = this.getResultContainer(options.headerTitle);
        var content = Coveo.$$("div");
        content.append(resultContainer.el);
        results.forEach(function (result) {
            var oneRowOfContent = template.instantiateToElement(result);
            var rowElement = Coveo.$$(oneRowOfContent);
            rowElement.addClass("CoveoResult coveo-omnibox-selectable");
            rowElement.on("click keyboardSelect", function () {
                _this.onOmniboxRowClicked(result);
            });
            content.append(oneRowOfContent);
        });
        return content.el;
    };
    OmniboxResultListHandler.prototype.populateOmniboxResultList = function (populateOmniboxObject, options, queryController) {
        var _this = this;
        var queryBuilder = queryController.createQueryBuilder(options);
        if (options.queryExpression && typeof (options.queryExpression) === "string") {
            queryBuilder.advancedExpression.add(options.queryExpression);
        }
        queryBuilder.numberOfResults = options.numberOfResults;
        var query = queryBuilder.build();
        var promise = this.executeSearchQuery(query)
            .then(function (response) {
            if (response.totalCount > 0) {
                var elementToReturn = _this.buildOmniboxContent(response.results, options);
                var objectToReturn = {
                    zIndex: options.omniboxDataRowIndex,
                    element: elementToReturn
                };
                return objectToReturn;
            }
            else {
                return { element: undefined };
            }
        });
        populateOmniboxObject.rows.push({ deferred: promise });
    };
    OmniboxResultListHandler.prototype.executeSearchQuery = function (query) {
        return Coveo.SearchEndpoint.endpoints["default"].search(query);
    };
    OmniboxResultListHandler.prototype.getResultContainer = function (captionText) {
        var resultContainer = Coveo.$$("div");
        resultContainer.addClass("coveo-omnibox-result-list-header");
        resultContainer.append(this.getIcon().el);
        resultContainer.append(this.getCaption(captionText).el);
        return resultContainer;
    };
    OmniboxResultListHandler.prototype.getIcon = function () {
        var iconResultList = Coveo.$$("span");
        iconResultList.addClass("coveo-icon-omnibox-result-list");
        return iconResultList;
    };
    OmniboxResultListHandler.prototype.getCaption = function (captionText) {
        var caption = Coveo.$$("span");
        caption.addClass("coveo-caption");
        caption.el.textContent = captionText;
        return caption;
    };
    OmniboxResultListHandler.omniboxDataRowIndexCounter = 0;
    return OmniboxResultListHandler;
}());
exports.__esModule = true;
exports["default"] = OmniboxResultListHandler;



//////////////////
// WEBPACK FOOTER
// ./Base/OmniboxResultList/OmniboxResultListHandler.ts
// module id = 13
// module chunks = 0